export type ClosureMode = 'deactivate' | 'delete'

export const closureContent = {
  deactivate: {
    info: {
      title: 'Deactivate account',
      subtitle:
        'If you deactivate, your account will be disabled and your plan cancelled. You can log back in anytime to reactivate.',
      cardLabel: 'While deactivated:',
      bullets: [
        "You won't be able to access your account, registrations, or plan benefits.",
        "You won't be able to register new works.",
        'Pending transactions on your registrations will be cancelled.',
        'Any outstanding balance must be paid in full before you can reactivate.',
      ],
      feesIntro:
        'Deactivating does not stop fees from accruing on your account. Fees tied to maintaining your existing registrations will continue and must be paid to keep them active.',
      payVerb: 'deactivate',
      primaryWithBalance: 'Pay and deactivate',
      primaryNoBalance: 'Deactivate',
      secondary: 'Keep account active',
    },
    confirm: {
      title: 'Confirm deactivation',
      bodyAfterBalance:
        ', and I acknowledge that this charge is final and non-refundable. I understand that my account will be deactivated and my registrations will no longer be accessible, and that I can reactivate at any time to restore access. I further acknowledge that deactivation does not relieve me of fees that may continue to accrue on my account, and that such fees remain my responsibility under the Terms.',
      bodyNoBalance:
        "Your account will be deactivated and your registrations will no longer be accessible. You can reactivate at any time to restore access. Any fees owed under the Terms remain your responsibility. Once confirmed, you'll receive an email confirming your account has been deactivated.",
      checkboxNoBalance: '',
      primaryWithBalance: 'Agree, deactivate account',
      primaryNoBalance: 'Deactivate account',
      secondary: 'Keep account active',
    },
    success: {
      title: 'Your account is being deactivated',
      body: "You'll receive a confirmation email and an invoice for any balance paid. To reactivate, log back in anytime.",
    },
  },
  delete: {
    info: {
      title: 'Delete account',
      subtitle: 'Deletion is permanent and cannot be undone.',
      cardLabel: 'If you delete your account:',
      bullets: [
        'Access to your account, registrations, and plan benefits ends immediately.',
        'Your account information will be permanently removed.',
        'Your registrations remain on Dacr as evidentiary records. Your name and information on existing registrations and past transactions will not be removed.',
        'Pending transactions on your registrations will be cancelled.',
      ],
      feesIntro:
        'Deletion does not stop fees from accruing on your account. Because your registrations remain active on Dacr, fees tied to maintaining them will continue and remain your responsibility.',
      payVerb: 'delete your account',
      primaryWithBalance: 'Pay and delete account',
      primaryNoBalance: 'Delete account',
      secondary: 'Keep my account',
    },
    confirm: {
      title: 'Confirm deletion',
      bodyAfterBalance:
        ' and I acknowledge that this charge is final and non-refundable. I understand that deleting my account is permanent and cannot be undone, that my registrations will remain on Dacr as evidentiary records, and that any fees that may continue to accrue on my account remain my responsibility under the Terms.',
      bodyNoBalance:
        "Deleting your account is permanent and cannot be undone. You will permanently lose access to all of your registrations, and they cannot be recovered. Any fees owed under the Terms remain your responsibility. Once confirmed, you'll receive an email confirming your account has been deleted.",
      checkboxNoBalance:
        'I understand that deleting my account is permanent, cannot be undone, and that I will permanently lose access to all of my registrations.',
      primaryWithBalance: 'Agree, delete account',
      primaryNoBalance: 'Delete account',
      secondary: 'Keep my account',
    },
    success: {
      title: 'Your account is being deleted',
      body: "You'll receive a confirmation email and an invoice for any balance paid.",
    },
  },
} as const
